import React, { useState } from 'react'
import styled, { css } from 'styled-components'

import ComboBox from 'components/ComboBox'

import Api from 'services/api'

import { color } from 'styles/colors'

import { Device } from 'types/Device'
import GA4 from 'helpers/ga4'

const OPTIONS = ['', 'Resolved', 'Scheduled Repair', 'Scheduled Maintenance',
  'Customer Action Required', 'Actively Monitoring', 'Ordered Parts', 'Won\'t Fix']

type props = {
  device: Device
}

const ActionTakenInput = ({ device }: props) => {
  const [savedDispositionAction, setSavedDispositionAction] = useState(device.dispositionAction || '')
  const [comboBoxValue, setComboBoxValue] = useState(device.dispositionAction || '')
  const [displaySaved, setDisplaySaved] = useState(false)
  const [displayError, setDisplayError] = useState(false)
  let timeOut

  const sendGA4Event = (comboBox: string) => {
    const ga4Event = {
      category: 'Customer List Page',
      action: 'Change Action Taken',
      label: `Action: ${comboBox}`
    }

    GA4.sendEvent(ga4Event)
  }

  const callApi = (comboBox:string) => {
    setDisplaySaved(false)
    setDisplayError(false)
    if (timeOut) clearTimeout(timeOut)

    if (comboBox !== savedDispositionAction) {
      sendGA4Event(comboBox)
      Api.Device.update(device.dealerId, device.deviceId, {
        ...device,
        dispositionAction: comboBox
      })
        .then(() => {
          setDisplaySaved(true)
          setComboBoxValue(comboBox)
          setSavedDispositionAction(comboBox)
        })
        .catch(() => {
          setDisplayError(true)
        })
        .finally(() => {
          timeOut = setTimeout(() => {
            setDisplaySaved(false)
            setDisplayError(false)
          }, 3000)
        })
    }
  }

  const onKeyUp = (event) => {
    if (event.key === 'Enter') {
      callApi(event.target.value)
    }
  }

  return (
    <>
      <S.ComboBox
        value={comboBoxValue}
        aria-label={`device id ${device.deviceId} disposition action`}
        options={OPTIONS}
        onBlur={(event) => { callApi(event.target.value) }}
        onSelectChange={(event) => { callApi(event.target.value) }}
        onInputChange={(event) => { setComboBoxValue(event.target.value) }}
        onKeyUp={onKeyUp}
      />

      <S.SavedMessage isDisplayed={displaySaved}>
        <span className="icon-ok" />
        <span> Saved!</span>
      </S.SavedMessage>

      <S.ErrorMessage isDisplayed={displayError}>
        <span className="icon-remove" />
        <span> Error!</span>
      </S.ErrorMessage>
    </>
  )
}

export default ActionTakenInput

const saveMessageStyle = css<{ isDisplayed: boolean }>`
  text-align: right;
  margin-bottom: -7px;
  padding-top: 5px;
  opacity: ${({ isDisplayed }) => isDisplayed ? '1' : '0'};
  transition: all .25s ease;
`

const S = {
  ComboBox: styled(ComboBox) <{ onBlur: (event) => void, onKeyUp: (event) => void }>`
    margin-bottom: 0;
  `,
  SavedMessage: styled.div.withConfig({
    shouldForwardProp: (prop) => !['isDisplayed'].includes(prop)
  })<{ isDisplayed: boolean }>`
    ${saveMessageStyle}

    color: ${color('successText')};
  `,
  ErrorMessage: styled.div.withConfig({
    shouldForwardProp: (prop) => !['isDisplayed'].includes(prop)
  })<{ isDisplayed: boolean }>`
    ${saveMessageStyle}
    margin-top: -26px;
    color: ${color('errorText')};
  `
}
